<template>
  <div>
    <!-- Only show breadcrumbs when not in embedded mode -->
    <div v-if="!embedded" class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    <div class="p-6 pb-0">

        <div class="flex justify-between items-start mb-4">
            <button @click="showDeleteModal = true" class="text-white bg-red-500 font-medium rounded-lg text-sm px-4 py-2.5 text-center h-fit hover:bg-red-600">{{ $t('go.actions.delete') }}</button>
            <a :href="emlurl" class="text-white bg-gray-500 font-medium rounded-lg text-sm px-4 py-2.5 text-center h-fit hover:bg-gray-600">{{ $t('go.actions.download_eml') }}</a>
            <button 
                v-if="embedded && senderEmail && extradata.weborders_head_id == null" 
                @click="createOrderFromEmail"
                class="text-white bg-blue-500 font-medium rounded-lg text-sm px-4 py-2.5 text-center hover:bg-blue-600"
                title="Crea un nuovo ordine precompilato con i dati del mittente"
            >
                {{ $t('go.actions.new_order') }}
            </button>
            <button 
                v-if="embedded && senderEmail && extradata.weborders_head_id != null" 
                @click="createOrderFromEmail"
                class="text-white bg-blue-500 font-medium rounded-lg text-sm px-4 py-2.5 text-center hover:bg-blue-600"
                title="Apri l'ordine associato a questa email"
            >
                {{ $t('go.actions.open_related_order') }}
            </button>
        </div>
        <div>
            <h2>{{ $t('go.fields.subject') }}: {{ extradata.subject }}</h2>
            <h2>{{ $t('go.fields.sender') }}: {{ extradata.sender }}</h2>
            <h2>{{ $t('go.fields.date_label') }}: {{ formatDateTime(extradata.date) }}</h2>

            <div class="border rounded-lg overflow-hidden shadow-sm px-2 py-2 grid grid-cols-1 md:grid-cols-3 gap-4">
                <div v-if="admin">
                  <label class="block text-gray-700">{{ $t('go.fields.assigned_user') }}</label>
                  <v-select 
                      :options="users"
                      :reduce="user => user.id"
                      v-model="extradata.user_id"
                      label="name"
                      placeholder="Seleziona utente..." 
                      class="w-full"
                  >
                  </v-select>
                </div>
                <div>
                  <label class="block text-gray-700">{{ $t('go.fields.priority_label') }}</label>
                  <input class="p93__input" v-model="extradata.priority" @input="validatePriority"/>
                </div>
                <div>
                    <label>&nbsp;</label>
                    <button class="text-white bg-blue-500 font-medium rounded-lg text-sm px-4 text-center hover:bg-blue-600 w-full py-3" @click="saveAssignAndPriority">{{ $t('go.actions.save') }}</button>
                </div>
            </div>
            
        </div>
        <div id="content" v-html="mailcontent">
        </div>
        <div v-if="attachments && attachments.length > 0" class="mb-1">
          <h2 class="text-2xl font-semibold mb-4">{{ $t('go.lista_mail.attachments_title') }}</h2>
          <div>
              <div class="inline-flex border rounded-lg overflow-hidden shadow-sm mb-2 mr-2" style="width: fit-content; display:inline-block" v-for="attachment in attachments" :key="attachment.index">
                  <!-- Parte sinistra: nome allegato -->
                  <button
                  class="px-3 py-1 text-left hover:bg-gray-100"
                  @click="openAttachmentInline(attachment)"
                  >
                  {{ attachment.title }}
                  </button>
                  <!-- Parte destra: icona download -->
                  <button
                  class="flex items-center justify-center px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white"
                  @click="openAttachment(attachment)"
                  >
                  <v-icon name="md-arrowdownward" scale="1.2" />
                  </button>
              </div>
          </div>
        </div>
        <iframe :src="attachmentURL" id="attachments" style="width:100%; height:0px; border:none;overflow:hidden;"></iframe> 
    </div>
  </div>


    <ConfirmationModal :show="showDeleteModal" @close="showDeleteModal = false">
        <template #title>
            {{ $t('go.modals.confirm_delete_mail_title') }}
        </template>

        <template #content>
            {{ $t('go.modals.confirm_delete_mail_content') }}
        </template>

        <template #footer>
            <button @click="showDeleteModal = false"
                    class="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600 mr-2">
                    {{ $t('go.actions.cancel') }}
            </button>
            <button @click="deleteMail" class="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600">
                {{ $t('go.actions.confirm') }}
            </button>
        </template>
    </ConfirmationModal>
</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';
import ConfirmationModal from '@/Components/ConfirmationModal.vue';

export default {
  //props: ['mailcontent', 'emlurl', 'embedded', ],
  emits: ['create-order-from-email', 'refresh-list'],
  props: ['mailcontent', 'emlurl', 'embedded', 'extradata', 'attachments', 'admin', 'users', 'senderEmail'],
  components: {
    Link,
    BreadCrumbs,
    Pagination,
  },
  data() {
    return {
      search: this.filters?.search || "",
      attachmentURL: '',
      showDeleteModal: false
    };
  },
  computed: {
    navigation() {
      return [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('go.breadcrumb.gestione_ordini'), href: route('modules.home', 'gestione-ordini') },
        { name: this.$t('go.breadcrumb.visualizza_mail'), href: '#' }
      ];
    }
  },
  methods: {
    createOrderFromEmail() {
      this.$emit('create-order-from-email', {'senderEmail' : this.senderEmail, 'extradata' : this.extradata });
    },
    saveAssignAndPriority(){
        axios.post(route('modules.ordini.savemailedits'), { id: this.$props.extradata.id, user_id: this.extradata.user_id, priority: this.extradata.priority })
          .then(response => {
            if (response.data.success) {
                this.$emit('refresh-list');
            }
          })
          .catch(error => {
            console.error("Errore nell'eliminazione della mail:", error);
        });
    },
    openAttachment(attachment) {
        const downloadURL = route('modules.ordini.allegato', { uuid: this.$props.extradata.id, index: attachment.index, download: 1 });
        window.open(downloadURL, '_blank');
    },
    openAttachmentInline(attachment) {

        if (this.attachmentURL == route('modules.ordini.allegato', { uuid: this.$props.extradata.id, index: attachment.index, download: 0 })) {
            // Se l'allegato è già aperto, non fare nulla
            return;
        }

        this.attachmentURL = route('modules.ordini.allegato', { uuid: this.$props.extradata.id, index: attachment.index, download: 0 });
        const iframe = document.getElementById("attachments");
        iframe.style.removeProperty("height"); // Reset height before loading new content
        // Funzione per adattare e zoomare l'iframe
        const adaptIframe = () => {
            const availableHeight = window.innerHeight - iframe.getBoundingClientRect().top - 40;
            iframe.style.height = availableHeight + "px";
            // Zoom dinamico (scale) solo se non PDF
            if (attachment.title.indexOf(".pdf") === -1) {
                const contentDoc = iframe.contentWindow?.document;
                if (contentDoc && contentDoc.body) {
                    // Calcola lo scale in base alla larghezza disponibile
                    const scale = Math.min(1, iframe.clientWidth / contentDoc.body.scrollWidth);
                    contentDoc.body.style.transform = `scale(${scale})`;
                    contentDoc.body.style.transformOrigin = "top left";

                    // Riduci altezza iframe se il contenuto zoomato è più basso
                    const contentHeight = contentDoc.body.scrollHeight * scale;
                    if (contentHeight < availableHeight) {
                        iframe.style.height = contentHeight + "px";
                    }
                }
            } else {
                iframe.style.removeProperty("height");
                iframe.style.aspectRatio = "1.33";
            }
        };
        adaptIframe();
        iframe.onload = function() {
            adaptIframe();
        };
        window.addEventListener('resize', adaptIframe);
        // ResizeObserver per il contenitore padre (SplitView)
        if (iframe.__resizeObserver) {
            iframe.__resizeObserver.disconnect();
        }
        const parent = iframe.parentElement;
        if (parent) {
            const ro = new ResizeObserver(() => {
                adaptIframe();
            });
            ro.observe(parent);
            iframe.__resizeObserver = ro;
        }
    },
    deleteMail() {
        axios.post(route('modules.ordini.deletemail'), { id: this.$props.extradata.id })
          .then(response => {
            if (response.data.success) {
                if (this.embedded) {
                    // La struttura potrebbe cambiare, cerca il primo parent con funzione backToList e chiamala
                    let parent = this.$parent;
                    while (parent) {
                        if (parent.backToList) {
                            parent.backToList();
                            return;
                        }
                        parent = parent.$parent;
                    }
                }
                else router.visit(route('modules.ordini.listamail'));
            }
          })
          .catch(error => {
            console.error("Errore nell'eliminazione della mail:", error);
        });
    },
    autoOpenPDF(list){
        if (list && list.filter(x => x.title.indexOf('.pdf') !== -1).length > 0) {
            this.openAttachmentInline(list.filter(x => x.title.indexOf('.pdf') !== -1)[0]);
        }
    },
    validatePriority(){
        this.extradata.priority = this.extradata.priority.replace(/\D+/g, '');
        this.extradata.priority = this.extradata.priority.substring(0, 4);
    }
  },
  watch: {
    attachments: {
        handler(newVal) {
            // Quando cambia l'email, resetta l'URL dell'allegato
            document.getElementById("attachments").style.height = 0;
            this.attachmentURL = "";

            this.autoOpenPDF(newVal);
        },
        deep: true
    }
  },
  mounted()
  {
     this.autoOpenPDF(this.attachments);
  }
};
</script>